var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col space-y-3"},[_vm._t("default"),(_vm.isError)?_c('div',{staticClass:"text-red mt-2"},[_vm._v(" "+_vm._s(_vm.errorText)+" ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }